var _defs, _style, _path, _use, _tspan, _tspan2, _tspan3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCsvStackDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 199,
    height: 177,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMcAAACxAgMAAAANEEGJAAAAAXNSR0IB2cksfwAAAAlQTFRF39/f39/fAAAAXJGfiQAAAAN0Uk5TAP8AaVI5rAAAAFRJREFUeJzt2TERgEAMAMGkpX8/mHh/SMEPIp7iDSQFBTN7/Sq4jE7jjFiJIMjn5LiK5LkRBEEQBEEQBEEQBEEQBEEQBEEQBPknKbdP4myZQBCkRV4P+wXk8Cr6lgAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: none;stroke: #dfdfdf;stroke-miterlimit:100;stroke-width: 18 } \n\t\t.t1 { font-size: 160px;fill: #dfdfdf;font-weight: 700;font-family: \"NotoIKEALatin-Bold\", \"Noto IKEA Latin\" } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s0",
    d: "m19 41h181v159h-181z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Shape 1 copy",
    href: "#img1",
    x: 40,
    y: 62
  })), /*#__PURE__*/React.createElement("text", {
    id: "xls",
    style: {
      transform: "matrix(.5,0,0,.5,56,85.5)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 121.6,
    className: "t1"
  }, "x")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    y: 121.6,
    className: "t1"
  }, "l")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    y: 121.6,
    className: "t1"
  }, "s\n"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCsvStackDisabled);
export default __webpack_public_path__ + "static/media/ic_csv_stack_disabled.027d82944fa98efc835ca588e9c7173a.svg";
export { ForwardRef as ReactComponent };